import { useContext } from "react";

import { MatchContext, UserInfo } from "../../context";
import useTrackEvent from "./use-track-app-event";
import { useMutation } from "@apollo/client";
import { SEND_INCLUDE_IN_FORECAST } from "../../mutations/table-data.gql";

const useHighlightTableItem = () => {
  const { state, dispatch } = useContext(MatchContext);
  const trackEvent = useTrackEvent();
  const { userId, username } = useContext(UserInfo);
  const [includeInForecast, { loading: sendLoading }] = useMutation(
    SEND_INCLUDE_IN_FORECAST
  );

  const handleClick = async (
    value: string,
    higlightType: string,
    stateProp: string,
    trackEventType: string = ""
  ): Promise<void> => {
    if (trackEventType) trackEvent(trackEventType, { value });

    if (state[stateProp].includes(value)) {
      await dispatch({
        type: higlightType,
        payload: state[stateProp].filter((item: any) => item !== value),
      });

      if (state.stockpileName && state.requestId) {
        await includeInForecast({
          variables: {
            stockpileId: value,
            requestId: state.requestId,
            userInfo: { userId, username },
            inputStockpile: state.stockpileName,
          },
        });
      }
    } else {
      dispatch({
        type: higlightType,
        payload: [...state[stateProp], value],
      });
    }
  };

  return handleClick;
};

export default useHighlightTableItem;
